import styleSearch from "./AppSearchBox.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const iconLeft = classNames(
    "tg-icons-LeftArrow",
    styleSearch["leftArrow"],
    styleSearch["icon-placement"],
);
const iconMagnifier = classNames(
    "tg-icons-Magnifier",
    styleSearch["icon-placement"],
);

function shouldWeShowSuggestionText(suggestedText, searchValue) {
    return suggestedText !== "" && searchValue.length > 3 &&
        `${suggestedText}`.startsWith(searchValue)
        && suggestedText !== searchValue;
}

const AppSearchBox = ({
  searchValue,
  suggestedText = "",
  keydownSearchHandler,
  keyupSearchHandler,
  setSearchValue,
  inputFieldRef,
  clearSearch,
  goBack,
}) => {
  const [isDrugPage, setIsDrugPage] = useState(false);
  const showSuggestedText = shouldWeShowSuggestionText(
    suggestedText,
    searchValue,
  );

  const suggestionText = shouldWeShowSuggestionText
    ? suggestedText.slice(searchValue.length)
    : "";

  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname && pathname.includes("drugLanding")) {
      setIsDrugPage(true);
    }
  }, []);

  return (
    <div className={classNames(styleSearch["searchContainer"], "size-18")}>
      <i
        className={searchValue?.length > 0 ? iconLeft : iconMagnifier}
        onClick={goBack}
        data-testid="search-icon"
      />
      {showSuggestedText && (
        <>
          <span
            id="autoCompleteText"
            data-testid="autoCompleteText"
            aria-labelledby={"searchBoxEnhanced"}
            className={classNames(styleSearch["suggestedText"], "medium")}
          >
            <span className={classNames(styleSearch.typedText)}>
              {searchValue}
            </span>
            <span className={classNames(styleSearch.ghostText)}>
              {suggestionText}
            </span>
          </span>
        </>
      )}
      <input
        type="text"
        enterKeyHint="search"
        name="appendedinputbuttons"
        id="searchBoxEnhanced"
        className={classNames(styleSearch.inputsearch)}
        placeholder={isDrugPage ? "Search for a drug" : "Search"}
        autoComplete="off"
        onKeyUp={(e) => keyupSearchHandler(e)}
        onKeyDown={keydownSearchHandler}
        onMouseUp={(e) => {
          if (showSuggestedText) {
            setSearchValue(suggestedText);
          }
          keyupSearchHandler(e);
        }}
        value={searchValue?.toLowerCase()}
        onChange={(e) => {
          setSearchValue(e.target.value);
        }}
        ref={inputFieldRef}
        aria-autocomplete="both"
        aria-controls="searchResults autoCompleteText"
        data-testid="search-input"
        autoFocus
      />
      {searchValue !== "" && (
        <button
          onClick={clearSearch}
          aria-label="Clear Search"
          data-testid="clear-button"
          type="button"
          className={styleSearch["clear-button"]}
        >
          <i
            className={classNames(
              `tg-icons-Xmark ${styleSearch["clear-placement"]}`,
            )}
            data-testid="clear-icon"
          />
        </button>
      )}
    </div>
  );
};

AppSearchBox.propTypes = {
  searchValue: PropTypes.string.isRequired,
  suggestedText: PropTypes.string,
  keydownSearchHandler: PropTypes.func.isRequired,
  keyupSearchHandler: PropTypes.func.isRequired,
  setSearchValue: PropTypes.func.isRequired,
  inputFieldRef: PropTypes.shape({ current: PropTypes.any }).isRequired,
  clearSearch: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
};

export default AppSearchBox;
